<template>
	<v-fade-transition name="fade">
		<v-container 
			fill-height
			grid-list-md 
			fluid 
			class="main-container"
		>
			<v-layout 
				column
			>
				<v-flex md3>
					<v-layout row wrap fill-height>
						<v-flex xs12 md8>
							<estates-list 
								:estates="filteredVisibleEstates"
							/>
						</v-flex>
						<v-flex xs12 md4>
							<global-variables />
						</v-flex>
					</v-layout>
				</v-flex>
				
				<v-flex md9>
					<v-layout row wrap fill-height>
						<v-flex xs12 md4>
							<estates-map
								:estates="estatesForSale"
							/>
						</v-flex>
						<v-flex xs12 md4>
							<estate-details 
								:selected-estate="selectedEstate"
							/>
						</v-flex>
						<v-flex v-if="user" xs12 md4>
							<wallet
								:estates="userEstates" 
							/>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-container>
	</v-fade-transition>
</template>

<script>
import { LOAD_ESTATES } from '../store/actions'
import { mapGetters, mapState } from 'vuex'

export default {
	data () {
		return {

		}
	},

	computed: {
		...mapGetters ([
			'estates', 
			'loadingEstates',
			'userEstates',
			'estatesForSale'
		]),
		...mapState ({
			user: state => state.auth.user,
			selectedEstate: state => state.estates.selectedEstate,
			visibleEstates: state => state.estates.visibleEstates
		}),

		filteredVisibleEstates () {
			return this.visibleEstates.length && this.user ? this.visibleEstates.filter (estate => { return estate.owner != this.user.uid}) : []
		},
	},

	created: function () {
		this.$store.dispatch (LOAD_ESTATES)
	},

	methods: {

	}
}
</script>

<style lang="scss">
@import '@/styles/index.scss';

.main-container {
	background-color: $primary;
}
</style>
